import * as React from 'react';
import Transition from 'react-motion-ui-pack';
import {IOuter} from './Animation.types';

export const Animation: React.FunctionComponent<IOuter> = ({
  animationKey,
  children,
  motions = DEFAULT_MOTION,
  className,
  wrapperClassName,
}) => {
  const {enter, leave} = motions;

  return (
    <div className={className} key={animationKey}>
      <Transition enter={enter} leave={leave}>
        <div className={wrapperClassName} key={`${animationKey}_animation`}>
          {children}
        </div>
      </Transition>
    </div>
  );
};
const DEFAULT_MOTION = {
  enter: {
    opacity: 1,
  },
  leave: {
    opacity: 0,
  },
};

Animation.displayName = 'Animation';
